import * as tslib_1 from "tslib";
import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
import { observer } from 'mobx-react';
import { getStartDate, getEndDate } from '../selectors/getStoreProperties';
import AutomaticRepliesDateTimePicker from './AutomaticRepliesDateTimePicker';
var styles = require('./AutomaticRepliesDateRangeSelector.scss');
var AutomaticRepliesDateRangeSelector = /** @class */ (function (_super) {
    tslib_1.__extends(AutomaticRepliesDateRangeSelector, _super);
    function AutomaticRepliesDateRangeSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Handler on start date changed
         * @param {DisplayDate} date selected date
         */
        _this.startDateSelected = function (date) {
            _this.setState({ startDate: date });
            if (!!date && _this.props.onStartDateSelection) {
                _this.props.onStartDateSelection(date);
            }
        };
        /**
         * Handler on end date changed
         * @param {DisplayDate} date selected date
         */
        _this.endDateSelected = function (date) {
            _this.setState({ endDate: date });
            if (!!date && _this.props.onEndDateSelection) {
                _this.props.onEndDateSelection(date);
            }
        };
        return _this;
    }
    AutomaticRepliesDateRangeSelector.prototype.render = function () {
        var startDate = getStartDate();
        var endDate = getEndDate();
        return (React.createElement("div", null,
            React.createElement(AutomaticRepliesDateTimePicker, { pickerStyle: styles.startTimePickerFull, labelStyle: styles.startTime, labelText: strings.options_automaticReplies_emailReplies_startTime, date: startDate, dateSelected: this.startDateSelected, dateAriaLabel: strings.options_automaticReplies_emailReplies_startTime_selectDate, onTimeChanged: this.props.onStartTimeChanged, timeArialabel: strings.options_automaticReplies_emailReplies_startTime_selectTime, isEnabled: this.props.isEnabled }),
            React.createElement(AutomaticRepliesDateTimePicker, { pickerStyle: styles.endTimePickerFull, labelStyle: styles.endTime, labelText: strings.options_automaticReplies_emailReplies_endTime, date: endDate, dateSelected: this.endDateSelected, dateAriaLabel: strings.options_automaticReplies_emailReplies_endTime_selectDate, onTimeChanged: this.props.onEndTimeChanged, timeArialabel: strings.options_automaticReplies_emailReplies_endTime_selectTime, isEnabled: this.props.isEnabled })));
    };
    AutomaticRepliesDateRangeSelector = tslib_1.__decorate([
        observer
    ], AutomaticRepliesDateRangeSelector);
    return AutomaticRepliesDateRangeSelector;
}(React.Component));
export default AutomaticRepliesDateRangeSelector;
//# sourceMappingURL=AutomaticRepliesDateRangeSelector.js.map